<template>
  <div class="search-area">
    <input
      ref="searchInput"
      type="text"
      class="search-input"
      placeholder="扫码或输入条码 (Enter)"
      v-model="searchValue"
      @keyup.enter="handleSearch"
      @input="handleInput"
    />
    <button class="btn-blue" @click="handleSearch">添加</button>
    <button class="btn-green" @click="showProductDialog = true">商品</button>
    
    <!-- 商品选择对话框 -->
    <el-dialog
      title="选择商品"
      :visible.sync="showProductDialog"
      width="80%"
      :close-on-click-modal="false"
      @opened="handleDialogOpened"
    >
      <div class="product-dialog-content">
        <!-- 左侧商品分组 -->
        <div class="product-category-list">
          <ul class="category-list">
            <li
              @click="selectCategory({ categoryId: '', categoryName: '全部' })"
              :class="{ 'selected': selectedCategoryId === '' }"
            >
              全部
            </li>
            <li
              v-for="(item, index) in productCategorys"
              :key="index"
              @click="selectCategory(item)"
              :class="{ 'selected': selectedCategoryId == item.categoryId }"
            >
              {{ item.categoryName }}
            </li>
          </ul>
        </div>
        
        <!-- 右侧商品列表 -->
        <div class="product-list">
          <div v-if="loading" class="loading-text">加载中...</div>
          <div v-else-if="products.length === 0" class="empty-text">暂无商品</div>
          <div v-else class="product-grid">
            <div
              v-for="(product, index) in products"
              :key="index"
              class="product-card"
              @click="selectProduct(product)"
            >
              <div class="product-image">
                <img
                  :src="product.coverPhoto || '/img/noPhoto.jpg'"
                  :alt="product.prodName"
                  @error="handleImageError"
                />
              </div>
              <div class="product-name">
                <div class="product-name-main">{{ product.prodName }}</div>
                <div class="product-spec-name" v-if="product.defaultSpecValue && product.defaultSpecValue.specName">
                  {{ product.defaultSpecValue.specName }}
                </div>
              </div>
              <div class="product-price">¥{{ (product.defaultSpecValue && product.defaultSpecValue.price) || '0.00' }}</div>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showProductDialog = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { queryProductAndSpec, queryProductCategory } from '@/api/goods/productApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'SearchArea',
  data() {
    return {
      searchValue: '',
      showProductDialog: false,
      productCategorys: [],
      products: [],
      selectedCategoryId: '',
      shopId: '',
      loading: false
    }
  },
  async created() {
    this.shopId = await getShopId()
  },
  mounted() {
    this.$refs.searchInput.focus()
  },
  methods: {
    handleSearch() {
      if (this.searchValue.trim()) {
        this.$emit('search', this.searchValue.trim())
        this.searchValue = ''
      }
    },
    handleInput() {
      this.$emit('input', this.searchValue)
    },
    async handleDialogOpened() {
      await this.loadProductCategorys()
      await this.loadProducts()
    },
    async loadProductCategorys() {
      try {
        const params = {
          page: 1,
          row: 50,
          shopId: this.shopId
        }
        const res = await queryProductCategory(params)
        this.productCategorys = res.data || []
      } catch (error) {
        console.error('获取商品分类失败:', error)
        this.$message.error('获取商品分类失败')
      }
    },
    async loadProducts() {
      this.loading = true
      try {
        const params = {
          page: 1,
          row: 100,
          shopId: this.shopId,
          categoryId: this.selectedCategoryId,
          state: '2002' // 只查询上架的商品
        }
        const res = await queryProductAndSpec(params)
        this.products = res.data || []
      } catch (error) {
        console.error('获取商品列表失败:', error)
        this.$message.error('获取商品列表失败')
      } finally {
        this.loading = false
      }
    },
    selectCategory(category) {
      this.selectedCategoryId = category.categoryId
      this.loadProducts()
    },
    selectProduct(product) {
      // 直接传递商品对象给父组件，让父组件添加到购物车
      this.$emit('add-product', product)
      this.showProductDialog = false
    },
    handleImageError(e) {
      e.target.src = '/img/noPhoto.jpg'
    }
  }
}
</script>

<style scoped>
.search-area {
  padding: 15px;
  border-bottom: 1px solid #cbd5e1;
  display: flex;
  gap: 10px;
  background: #f1f5f9;
}

.search-input {
  flex: 1;
  padding: 12px;
  font-size: 1.1rem;
  border: 2px solid #cbd5e1;
  border-radius: 6px;
  outline: none;
}

.search-input:focus {
  border-color: #2563eb;
}

.btn-blue {
  background: #2563eb;
  color: white;
  border: none;
  padding: 0 20px;
  border-radius: 6px;
  font-weight: bold;
  cursor: pointer;
  font-size: 1rem;
}

.btn-blue:hover {
  background: #1d4ed8;
}

.btn-blue:active {
  transform: scale(0.98);
}

.btn-green {
  background: #10b981;
  color: white;
  border: none;
  padding: 0 20px;
  border-radius: 6px;
  font-weight: bold;
  cursor: pointer;
  font-size: 1rem;
}

.btn-green:hover {
  background: #059669;
}

.btn-green:active {
  transform: scale(0.98);
}

/* 商品对话框样式 */
.product-dialog-content {
  display: flex;
  height: 500px;
  gap: 20px;
}

.product-category-list {
  width: 200px;
  border-right: 1px solid #e5e7eb;
  overflow-y: auto;
}

.category-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.category-list li {
  padding: 12px 16px;
  cursor: pointer;
  border-bottom: 1px solid #f3f4f6;
  transition: all 0.2s;
}

.category-list li:hover {
  background-color: #f9fafb;
}

.category-list li.selected {
  background-color: #409eff;
  color: white;
}

.product-list {
  flex: 1;
  overflow-y: auto;
}

.loading-text,
.empty-text {
  text-align: center;
  padding: 40px;
  color: #9ca3af;
}

.product-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
  gap: 16px;
  padding: 10px;
}

.product-card {
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 12px;
  cursor: pointer;
  transition: all 0.2s;
  text-align: center;
}

.product-card:hover {
  border-color: #409eff;
  box-shadow: 0 2px 8px rgba(64, 158, 255, 0.2);
  transform: translateY(-2px);
}

.product-image {
  width: 100%;
  height: 100px;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border-radius: 4px;
}

.product-image img {
  max-width: 100%;
  max-height: 100%;
  object-fit: cover;
}

.product-name {
  font-size: 14px;
  color: #374151;
  margin-bottom: 6px;
  min-height: 40px;
}

.product-name-main {
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-bottom: 2px;
}

.product-spec-name {
  font-size: 12px;
  color: #6b7280;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.product-price {
  font-size: 16px;
  font-weight: bold;
  color: #ef4444;
}
</style>

